// extracted by mini-css-extract-plugin
module.exports =  {"volume-control":"UG7BoPI","volumeControl":"UG7BoPI","on":"zy6LsB7","off":"rxFIlNm"};